var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.125V5.1C13 3.83988 13 3.20982 12.7548 2.72852C12.539 2.30516 12.1948 1.96095 11.7715 1.74524C11.2902 1.5 10.6601 1.5 9.4 1.5H4.6C3.33988 1.5 2.70982 1.5 2.22852 1.74524C1.80516 1.96095 1.46095 2.30516 1.24524 2.72852C1 3.20982 1 3.83988 1 5.1V12.9C1 14.1601 1 14.7902 1.24524 15.2715C1.46095 15.6948 1.80516 16.039 2.22852 16.2548C2.70982 16.5 3.33988 16.5 4.6 16.5H8.5M8.5 8.25H4M5.5 11.25H4M10 5.25H4M10.375 11.2517C10.5071 10.876 10.768 10.5593 11.1113 10.3575C11.4546 10.1557 11.8583 10.082 12.2508 10.1493C12.6433 10.2166 12.9993 10.4207 13.2557 10.7253C13.5122 11.03 13.6525 11.4155 13.6519 11.8138C13.6519 12.9379 11.9657 13.5 11.9657 13.5M11.9874 15.75H11.9949",
    stroke: "#081D3F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/Quiz.b1e4c85ec62dfe7600ea3d02fe49c512.svg";
export { ForwardRef as ReactComponent };